/**
 * Determine whether the authenticated user owns a group.
 *
 * `owner` (Task 10) is the transferable ownership field; it falls back to
 * `created_by` for any group payloads fetched before that field existed (or
 * from any endpoint not yet updated to serialize `owner`), since
 * `created_by` never changes and always reflected ownership before
 * ownership transfer was possible.
 *
 * @param {{owner?: number; created_by?: number} | undefined} group
 * @param {number | undefined} authUserId
 * @return {boolean}
 */
export const isGroupOwner = (
    group: {owner?: number; created_by?: number} | undefined,
    authUserId: number | undefined,
): boolean => {
    if (!group) return false;

    return (group.owner ?? group.created_by)?.toString() === authUserId?.toString();
};
